import { render, staticRenderFns } from "./CatalogPreviewPhoto.vue?vue&type=template&id=0bd9710d&scoped=true&"
import script from "./CatalogPreviewPhoto.vue?vue&type=script&lang=js&"
export * from "./CatalogPreviewPhoto.vue?vue&type=script&lang=js&"
import style0 from "./CatalogPreviewPhoto.vue?vue&type=style&index=0&id=0bd9710d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd9710d",
  null
  
)

export default component.exports